<template>
  <div class="settings-logs">
    <h2>{{ $t('settings.logs.title') }}</h2>

    <div class="buttons-container" v-if="!loadingLogs">
      <edit-button :editOptions="['getLogs']" @click="getLogs">
        <template>
          <span class="text">{{ $t('button.download.log') }}</span>
        </template>
      </edit-button>
      <div class="control delete">
        <a @click="remove" class="button">{{ $t('button.delete.log') }}</a>
      </div>
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import EditButton from '@/components/EditButton'
export default {
  components: {
    Loader,
    EditButton
  },
  data() {
    return {
      loadingLogs: false
    }
  },
  methods: {
    getLogs() {
      if (!this.loadingLogs) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/logs`
        this.loadingLogs = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            const a = document.createElement('a')
            a.href = data
            a.setAttribute('download', 'log_files.zip')
            a.click()
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.loadingLogs = false
          })
      }
    },
    remove() {
      let msg = `${this.$t('word.logs')}`
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', { msg })}?`,
        onConfirm: () => {
          if (!this.loadingLogs) {
            const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/logs`
            this.loadingLogs = true
            return fetch(url, {
              method: 'POST',
              credentials: 'include'
            })
              .then(res => {
                if (!res.ok) {
                  throw res.json()
                }
                return res.json()
              })
              .then(() => {
                this.$notify({
                  message: this.$t('notification.removed', {
                    msg: msg
                  }),
                  type: 'success'
                })
              })
              .catch(error =>
                error.then(data => {
                  this.$notify({
                    message: JSON.parse(data.message).message,
                    type: 'danger'
                  })
                })
              )
              .finally(() => {
                this.loadingLogs = false
              })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.settings-logs {
  margin-bottom: 3rem;
  .buttons-container {
    display: flex;
    .control.download {
      display: block;
      float: left;
      height: 1.35rem;
      font-size: 0.9em;
      .button {
        padding: 0;
        height: 100%;
        padding-right: 1.25rem;
        padding-left: 1.25rem;
        color: white;
        background-color: #4bbd4d;
        font-weight: bold;
      }
    }
    .control.delete {
      display: block;
      float: left;
      height: 1.35rem;
      font-size: 0.9em;
      margin-left: 1rem;
      .button {
        padding: 0;
        height: 100%;
        padding-right: 1.25rem;
        padding-left: 1.25rem;
        border-color: #d02129;
        color: #d02129;
      }
    }
  }
}
</style>
